import CloseRounded from '@mui/icons-material/CloseRounded';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { SupportChat } from './SupportChat';

/** The support chat in a dialog (the locked screen's "Send us a message"). */
export function SupportDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  const theme = useTheme();
  const small = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md" fullScreen={small}>
      <DialogTitle sx={{ pr: 6 }}>
        Message PackBytes support
        <IconButton
          aria-label="Close"
          onClick={onClose}
          sx={{ position: 'absolute', right: 12, top: 12 }}
        >
          <CloseRounded />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ pb: 2 }}>
        <SupportChat height={small ? 'calc(100dvh - 96px)' : 'min(560px, calc(100dvh - 160px))'} />
      </DialogContent>
    </Dialog>
  );
}
